import { CircularProgress } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useContext, type JSX } from 'react'
import RbacAccessDeniedPage from '~/components/communication/RbacAccessDeniedPage'
import { SupplyPage } from '~/components/routes/supply/supply-page'
import { AuthContext } from '~/utils/context/auth.context'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/supply/')({
  staticData: {
    permission: ['read', 'categories'],
  },
  component: SupplyRoute,
})
withRoutePermissions(Route)

// L'ability RBAC 'categories' (staticData ci-dessus) ne reflète pas le droit réellement
// exigé par l'API (stockReader) : sans ce garde, un admin sans STOCK_READER atteint la
// page et n'obtient qu'une erreur de chargement permanente.
function SupplyRoute(): JSX.Element {
  const { isLoading, hasRights } = useContext(AuthContext)

  if (isLoading) {
    return <CircularProgress />
  }

  if (!hasRights(['STOCK_READER'])) return <RbacAccessDeniedPage />
  return <SupplyPage />
}
